var handleCapabilities = function handleCapabilities(event, postMessageService) {
  try {
    var sourceWindow = event.source;
    var supported_messages = postMessageService.capabilities();
    postMessageService.sendResponse('lti.capabilities', {
      supported_messages: supported_messages
    }, sourceWindow, event.origin);
    return true;
  } catch (_unused) {
    return false;
  }
};
export default handleCapabilities;